export default "__VITE_ASSET__BPIlSHRG__"